import { render, staticRenderFns } from "./RemoveBtn.vue?vue&type=template&id=1c8e6a88&"
import script from "./RemoveBtn.vue?vue&type=script&lang=js&"
export * from "./RemoveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports